import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IBillTransactionType } from "./BillTransactionType.types";

export const FETCH_BILL_TRANSACTION_TYPE_FAILURE = "FETCH_BILL_TRANSACTION_TYPE_FAILURE";
export const FETCH_BILL_TRANSACTION_TYPE_PROGRESS =
  "FETCH_BILL_TRANSACTION_TYPE_PROGRESS";
export const FETCH_BILL_TRANSACTION_TYPE_SUCCESS = "FETCH_BILL_TRANSACTION_TYPE_SUCCESS";

export const fetchBillTransactionTypeProgress = () =>
  action(FETCH_BILL_TRANSACTION_TYPE_PROGRESS);
export const fetchBillTransactionTypeSuccess = (data: IBillTransactionType) =>
  action(FETCH_BILL_TRANSACTION_TYPE_SUCCESS, { data });
export const fetchBillTransactionTypeFailure = (errorMessage: string) =>
  action(FETCH_BILL_TRANSACTION_TYPE_FAILURE, { errorMessage });

export const fetchAccountingBillTransactionTypeAsync =
  (billTransactionTypeId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBillTransactionTypeProgress());

      const res = await api.get(
        `/accounting/get-account-bill-transaction-type?bill_transaction_type_id=${billTransactionTypeId}`
      );
      const data: IBillTransactionType[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchBillTransactionTypeSuccess(data[0]));
      }
    } catch (err: any) {
      dispatch(fetchBillTransactionTypeFailure("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingBillTransactionTypeAysnc =
  (
    data: IBillTransactionType,
    onCallback: (isSuccess: boolean, transaction_type_id: string | null) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.post("/accounting/edit-account-bill-transaction-type", {
        ...data,
      });
      const transactionTypeId = res.data.data.bill_transaction_type_id;
      const message = "Transaction saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true, transactionTypeId);
    } catch (err: any) {
      onCallback(false, null);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_BILL_TRANSACTION_TYPE_LIST_PROGRESS =
  "FETCH_BILL_TRANSACTION_TYPE_LIST_PROGRESS";
export const FETCH_BILL_TRANSACTION_TYPE_LIST_SUCCESS =
  "FETCH_BILL_TRANSACTION_TYPE_LIST_SUCCESS";
export const FETCH_BILL_TRANSACTION_TYPE_LIST_FAILURE =
  "FETCH_BILL_TRANSACTION_TYPE_LIST_FAILURE";

export const fetchBillTransactionTypeListProgress = () =>
  action(FETCH_BILL_TRANSACTION_TYPE_LIST_PROGRESS);
export const fetchBillTransactionTypeListSuccess = (data: IBillTransactionType[]) =>
  action(FETCH_BILL_TRANSACTION_TYPE_LIST_SUCCESS, { data });
export const fetchBillTransactionTypeListFailure = (errorMessage: string) =>
  action(FETCH_BILL_TRANSACTION_TYPE_LIST_FAILURE, { errorMessage });

export const fetchAccountingBillTransactionTypeListAsync = (
  pageNumber: number,
  rowsInPerPage: number,
  limit: number,
  status: string,
  date: IDataTableV2DateState["dates"],
  searchValue: IDatatableV2AdvancedSearchFilter
): ThunkAction<void, IStoreState, {}, AnyAction> => {
  return async (dispatch, getState) => {
    try {
      dispatch(fetchBillTransactionTypeListProgress());

      let finalUrl = `/accounting/get-account-bill-transaction-type?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-bill-transaction-type?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }

      const res = await api.get(finalUrl);
      const data: IBillTransactionType[] = res.data.data;
      dispatch(fetchBillTransactionTypeListSuccess(data));
    } catch (err: any) {
      dispatch(fetchBillTransactionTypeListFailure("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
};

export const fetchAllBillTransactionTypeListAsync = (): ThunkAction<
  void,
  IStoreState,
  {},
  AnyAction
> => {
  return async (dispatch, getState) => {
    try {
      dispatch(fetchBillTransactionTypeListProgress());
      const finalUrl = `/accounting/get-account-bill-transaction-type?status=ACTIVE`;

      const res = await api.get(finalUrl);
      const data: IBillTransactionType[] = res.data.data;
      dispatch(fetchBillTransactionTypeListSuccess(data));
    } catch (err: any) {
      dispatch(fetchBillTransactionTypeListFailure("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
};

export const CLEAR_BILL_TRANSACTION_TYPE = "CLEAR_BILL_TRANSACTION_TYPE";
export const clearBillTransactionType = () => action(CLEAR_BILL_TRANSACTION_TYPE);
